/**
 * 2 Hounds Design — Search Results Sorting (True Best Selling)
 *
 * When the user selects "Best selling", this script reorders the search results
 * using Shopify's Storefront API sales ranking.
 *
 * It preserves ALL search results (including description matches) and preserves
 * all server-rendered Okendo star ratings, badges, and pricing without losing any products.
 */
(function () {
  'use strict';

  var container = document.querySelector('.search-results');
  if (!container) return;

  var token = container.dataset.storefrontToken;
  var shopDomain = window.location.hostname;
  var apiVersion = '2024-04';

  var grid = container.querySelector('.search-results__grid');

  var params = new URLSearchParams(window.location.search);
  var currentSort = params.get('sort_by') || 'best-selling';

  // GraphQL query to get best-selling product handles
  var GQL_BEST_SELLING = [
    'query BestSellingRanking($first: Int!) {',
    '  products(first: $first, sortKey: BEST_SELLING) {',
    '    nodes {',
    '      handle',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function syncSelects(value) {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (s) {
      s.value = value;
    });
  }

  function updateUrl(sort) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort);
    window.history.pushState({}, '', url.href);
    syncPaginationLinks(sort);
  }

  function syncPaginationLinks(sortBy) {
    var activeSort = sortBy || (new URLSearchParams(window.location.search)).get('sort_by');
    if (activeSort) {
      var links = document.querySelectorAll('.pagination__element[href]');
      links.forEach(function (link) {
        try {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set('sort_by', activeSort);
          link.href = url.href;
        } catch (e) {}
      });
    }
  }

  function setLoading(on) {
    if (!grid) return;
    grid.style.opacity = on ? '0.4' : '1';
    grid.style.transition = 'opacity 0.2s ease';
  }

  // ── Reorder existing DOM cards by sales rank ───────────────────
  function reorderByBestSelling(rankedHandles) {
    if (!grid) return;
    var thumbs = Array.from(grid.querySelectorAll('.product-thumb'));
    if (!thumbs.length) return;

    var rankMap = {};
    rankedHandles.forEach(function (handle, index) {
      rankMap[handle] = index;
    });

    // Sort thumbs based on their index in the best-selling list
    thumbs.sort(function (a, b) {
      var linkA = a.querySelector('.product-thumb__title a');
      var linkB = b.querySelector('.product-thumb__title a');
      var handleA = linkA ? linkA.getAttribute('href').replace('/products/', '').split('?')[0].split('#')[0] : '';
      var handleB = linkB ? linkB.getAttribute('href').replace('/products/', '').split('?')[0].split('#')[0] : '';

      var rankA = rankMap.hasOwnProperty(handleA) ? rankMap[handleA] : 999999;
      var rankB = rankMap.hasOwnProperty(handleB) ? rankMap[handleB] : 999999;

      return rankA - rankB;
    });

    // Append in sorted order
    thumbs.forEach(function (thumb) {
      grid.appendChild(thumb);
    });

    setLoading(false);
  }

  var cachedRankings = null;

  function fetchAndSortBestSelling() {
    if (cachedRankings) {
      reorderByBestSelling(cachedRankings);
      return;
    }

    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);

    fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: GQL_BEST_SELLING,
        variables: {
          first: 250
        }
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.data && json.data.products && json.data.products.nodes) {
          var handles = json.data.products.nodes.map(function (n) { return n.handle; });
          cachedRankings = handles;
          reorderByBestSelling(handles);
        } else {
          setLoading(false);
        }
      })
      .catch(function (err) {
        console.warn('[StorefrontSearch] Error getting ranking:', err);
        setLoading(false);
      });
  }

  // ── Event Delegation for all sort dropdowns ────────────────────

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('select[name="sort_by"]')) {
      var val = e.target.value;
      syncSelects(val);

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', val);
      url.searchParams.delete('page');
      window.location.href = url.href;
    }
  });

  // If page loaded with sort_by=best-selling, reorder immediately
  if (currentSort === 'best-selling') {
    syncSelects('best-selling');
    fetchAndSortBestSelling();
  } else {
    syncSelects(currentSort);
  }

  syncPaginationLinks(currentSort);

})();
